import * as licensingActions from './actions';
import licensingEpics from './epics';
import reducer from './reducers';
import * as licensingSelectors from './selectors';
import * as licensingTypes from './types';

export { licensingActions, licensingEpics, licensingSelectors, licensingTypes };

export default reducer;
